import { RestUsersService } from '../users-service/rest-users-service';

const url = process.env.WEB_GATEWAY_URL + '/customer/';
export const restUsersCustomerService: RestUsersService = new RestUsersService(
  url
);
